export default "__VITE_ASSET__Cw3f2GGC__"